import(/* webpackMode: "eager", webpackExports: ["RecapVideoClient"] */ "/app/app/[locale]/(site)/recap-video/recap-video-client.tsx");
